import React, { createContext ,useState} from 'react'
import { useQueryParam, StringParam } from 'use-query-params';
import { useParams } from 'react-router-dom';


export const LanguageContext = createContext();
//export const LanguageContext = createContext({language:'he',switchLang:()=>{}});

export function ContextProvider({ children }) {

    //const [lang, setLang] = useQueryParam('lang', StringParam);
    const {langParam}=useParams();
    //const params=useParams();

    const switchLang=(lang)=>{
        setLangWeb({language:lang.toLocaleLowerCase(),switchLang})
        return false;
      }

    //const LanguageContext = createContext({language:'he',switchLang:()=>{}});
    //const language='he';
    const [langWeb,setLangWeb]=useState({language:langParam!=undefined?langParam:'he',switchLang})

   
    return (
        <LanguageContext.Provider value={langWeb}>
            {children}
        </LanguageContext.Provider>
    )
}